import React from 'react';
import PropTypes from 'prop-types';

const MarketingSkills = ({ type }) => {
  if (type === 'freelancer') {
    return (
      <>
        <li>
          <a href="/jobs/content-creators">Content creation jobs</a>
        </li>
        <li>
          <a href="/jobs/digital-marketers">Digital marketing jobs</a>
        </li>
        <li>
          <a href="/jobs/social-media-freelancers">
            Social media freelance jobs
          </a>
        </li>
        <li>
          <a href="/jobs/pr-freelancers">PR freelance jobs</a>
        </li>
        <li>
          <a href="/jobs/social-media-managers">Social media manager jobs</a>
        </li>
        <li>
          <a href="/jobs/pitch-deck-designers">Pitch deck designer jobs</a>
        </li>
        <li>
          <a href="/jobs/presentation-designers">Presentation designer jobs</a>
        </li>
      </>
    );
  }

  return (
    <>
      <li>
        <a href="/find/content-creators">Content creators</a>
      </li>
      <li>
        <a href="/find/digital-marketers">Digital marketers</a>
      </li>
      <li>
        <a href="/find/social-media-freelancers">Social media freelancers</a>
      </li>
      <li>
        <a href="/find/pr-freelancers">PR freelancers</a>
      </li>
      <li>
        <a href="/find/social-media-managers">Social media managers</a>
      </li>
      <li>
        <a href="/find/pitch-deck-designers">Pitch deck designers</a>
      </li>
      <li>
        <a href="/find/seo-experts">SEO experts</a>
      </li>
      <li>
        <a href="/find/copywriters">Copywriters</a>
      </li>
      <li>
        <a href="/find/ppc-managers">PPC managers</a>
      </li>
    </>
  );
};

MarketingSkills.propTypes = {
  type: PropTypes.string.isRequired,
};

export default MarketingSkills;
